module.exports = __webpack_public_path__ + "static/img/成二-邱連城.e1f3de0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成二-邱連城.jpg
// module id = owMG
// module chunks = 1